cockpitApp.filter('abs', function () {
  return function (input) {
    return $.isNumeric(input) ? Math.abs(input) : input;
  }
});
